package songwritersnotebook.app.utils

actual fun getTimeNanos(): Long {
    return (kotlinx.browser.window.performance.now() * 1_000_000).toLong()
}
